module.exports = __webpack_public_path__ + "img/santa_claus.b48d9cd1.svg";